import { ColumnDef } from "@tanstack/react-table";
import { MembershipDurationsProps } from "../../store/actionType";
import ActionButton from "../ActionButton";

export const TableColumns: ColumnDef<MembershipDurationsProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorFn: (row) => row?.price,
    id: "price",
    cell: (info) => info.getValue(),
    header: () => <span>Price(Nu.)</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.price_usd,
    id: "price_usd",
    cell: (info) => info.getValue(),
    header: () => <span>Price(USD.)</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.duration_type,
    id: "duration_type",
    cell: (info) => info.getValue(),
    header: () => <span>Duration Type</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row.package?.name ?? "no value",
    id: "package",
    cell: (info) => {
      const value = info.getValue() as string;
      return (
        <span style={{ color: value === "no value" ? "red" : "inherit" }}>
          {value}
        </span>
      );
    },
    header: () => <span>Package</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.description,
    id: "description",
    cell: (info) => info.getValue(),
    header: () => <span>Description</span>,
    filterFn: "equalsString",
  },
  {
    id: "action",
    cell: ({ row }) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <ActionButton items={row.original} />
        </div>
      );
    },
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
